module.exports = __webpack_public_path__ + "img/flowers-8013886_1280_thumb.d2c0b424.png";